const available = (): boolean => typeof navigator !== "undefined" && "mediaSession" in navigator;

/** What the lock screen and the notification shade show. */
export const setMediaMetadata = (title: string | undefined, authorAlias: string): void => {
  if (available() && title) {
    navigator.mediaSession.metadata = new MediaMetadata({ title, artist: authorAlias, album: "!tldr" });
  }
};

export type MediaActions = { play: () => void; pause: () => void; next: () => void; previous: () => void };

/** Hooks the lock screen's buttons up; returns what takes them away. */
export const bindMediaActions = (actions: () => MediaActions): (() => void) => {
  if (!available()) {
    return () => {};
  }
  const handlers: [MediaSessionAction, () => void][] = [
    ["play", () => actions().play()],
    ["pause", () => actions().pause()],
    ["nexttrack", () => actions().next()],
    ["previoustrack", () => actions().previous()],
  ];
  for (const [action, handler] of handlers) {
    navigator.mediaSession.setActionHandler(action, handler);
  }
  return () => {
    for (const [action] of handlers) {
      navigator.mediaSession.setActionHandler(action, null);
    }
  };
};
